import DateInput from './DateInput'

export default DateInput



// WEBPACK FOOTER //
// ./src/components/Form/components/DateInput/index.js